module.exports = __webpack_public_path__ + "img/29_56.3bf53e67.png";